import _ from 'lodash'

export default ({ areas }, { areaId: id }) => {
  if (_.isEmpty(id)) return

  return _.find(areas, { id }).mapImageUrl
}
